
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resurs-luotto",
      function () {
        return require("private-next-pages/resurs-luotto.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resurs-luotto"])
      });
    }
  